import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=0c32eb05&scoped=true"
import script from "./tree-node.vue?vue&type=script&lang=js"
export * from "./tree-node.vue?vue&type=script&lang=js"
import style0 from "./tree-node.vue?vue&type=style&index=0&id=0c32eb05&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32eb05",
  null
  
)

export default component.exports